import { View, Text, StyleSheet, Pressable } from 'react-native';
import { useRouter } from 'expo-router';
import { ArrowRight } from 'lucide-react-native';
import { ReactNode } from 'react';

const BG = '#050B17';
const CARD = 'rgba(255,255,255,0.06)';
const BORDER = 'rgba(255,255,255,0.10)';
const TEXT = '#F8FAFC';
const MUTED = '#9AA7B8';

interface AdminHeaderProps {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  rightActions?: ReactNode;
}

export default function AdminHeader({ title, subtitle, showBack = false, rightActions }: AdminHeaderProps) {
  const router = useRouter();

  return (
    <View style={styles.header}>
      {showBack && (
        <Pressable onPress={() => router.back()} style={styles.backBtn}>
          <ArrowRight size={20} color={TEXT} />
          <Text style={styles.backText}>חזור</Text>
        </Pressable>
      )}

      <View style={styles.headerContent}>
        <Text style={styles.title}>{title}</Text>
        {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
      </View>

      {rightActions && <View style={styles.actions}>{rightActions}</View>}
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    padding: 16,
    borderRadius: 16,
    backgroundColor: CARD,
    borderWidth: 1,
    borderColor: BORDER,
    gap: 12,
  },
  backBtn: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    gap: 8,
    alignSelf: 'flex-end',
  },
  backText: {
    fontSize: 14,
    fontWeight: '700',
    color: TEXT,
  },
  headerContent: {
    gap: 4,
  },
  title: {
    fontSize: 20,
    fontWeight: '900',
    color: TEXT,
    textAlign: 'right',
  },
  subtitle: {
    fontSize: 13,
    fontWeight: '600',
    color: MUTED,
    textAlign: 'right',
  },
  actions: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'flex-start',
  },
});